import { Button, Typography } from '@breetometer/components';
import { RemoveTeamMemberIcon } from 'BreetAssets';
import { getTeamMemberRoleLabel, handleApiError, showToast } from 'BreetHelpers';
import { useDeleteTeamMemberByIdMutation } from 'BreetRedux';
import { useCallback } from 'react';

import type { IDeleteTeamMemberChild } from './DialogRemoveTeamMember.helpers';

const Child = ({ teamMemberData, modalApis }: IDeleteTeamMemberChild) => {
	const [deleteTeamMember, { isLoading }] = useDeleteTeamMemberByIdMutation();

	const onDeleteMember = useCallback(() => {
		if (!teamMemberData?.data?.id) {
			showToast('error', 'Team member not found');
			return;
		}

		deleteTeamMember(teamMemberData.data.id)
			.unwrap()
			.then(() => {
				modalApis.handleModalCloseAll();
			})
			.catch(handleApiError);
	}, [deleteTeamMember, teamMemberData?.data?.id, modalApis]);

	return (
		<div className='remove-team-member bg-primary-500'>
			<RemoveTeamMemberIcon className='remove-team-member-icon' />
			<Typography
				as='h4'
				className='color-neutral-50'
			>
				Remove this Team Member?
			</Typography>

			<div className='profile bg-primary-400 theme-border-none'>
				<div className='profile-left'>
					<Typography
						as='h6'
						className='color-neutral-50'
					>
						{teamMemberData?.data?.fullName}
					</Typography>
					<Typography className='color-tertiary-300'>{teamMemberData?.data?.email}</Typography>
				</div>

				<div className='profile-role'>
					<div className='dot' />
					<Typography>{getTeamMemberRoleLabel(teamMemberData?.data?.role ?? 'owner')}</Typography>
				</div>
			</div>

			<div className='cta-remove'>
				<Button
					onClick={onDeleteMember}
					isLoading={isLoading}
				>
					Yes, Remove
				</Button>
			</div>
		</div>
	);
};

export default Child;
